import Select from 'gatsby-theme-core/src/components/form-elements/select';
import Checkbox from '../checkbox';
import Sizes from '../sizes';
import Energylabel from '../energylabel';

export default (type, forceType, selectionType) => {
  if (selectionType && !forceType) {
    switch (selectionType) {
      case 'checkbox':
        return Checkbox;
      case 'select':
        return Select;
      case 'default':
      default:
        break;
    }
  }
  switch (type) {
    case 'checkbox':
      return Checkbox;
    case 'select':
      return Select;
    case 'sizes':
      return Sizes;
    case 'energylabel':
      return Energylabel;
    default:
      return Select;
  }
};
